import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { map } from 'rxjs/operators'
import { Observable, of } from 'rxjs';
import { StorageService } from '../services/storage.service';
@Injectable({
    providedIn: 'root'
})
export class JwtAuthService {
    jwtPath!: string;
    webApiClientId!: string;
    constructor(
        private _http: HttpClient,
        private storage: StorageService) {
            //MW 12-07-2023 - having trouble accessing the environment files from here so using the location to set these variables instead
            if(window.location.hostname == 'localhost' || window.location.hostname == 'app-web-sngbarratt-customermanagement-dev.azurewebsites.net'){
                this.jwtPath = `https://web-api-dev.sngbarratt.com`
            }else if(window.location.hostname == 'app-web-sngbarratt-customermanagement-stage.azurewebsites.net'){
                this.jwtPath = `https://web-api-qa.sngbarratt.com`
            }else{
                this.jwtPath = `https://web-api.sngbarratt.com`
            }
            this.webApiClientId = `2FC6E2AC-18D6-462E-A662-FF6BC75968C9`
    }

    authCheck = () => {
        let jwtHelper = new JwtHelperService();
        if (this.storage.getStorageItem('sng-jwToken', true) && jwtHelper.isTokenExpired(this.storage.getStorageItem('sng-jwToken', true)) != true) {
            return true;
        } else {
            return false;
        }
    }

    getJwt = () => {
        return this.storage.getStorageItem('sng-jwToken', true);
    }

    getJwtRefreshToken = () => {
        return this.storage.getStorageItem('sng-jwtRefreshToken', true);
    }

    refreshToken = (): Observable<string> => {

        let refreshToken = this.storage.getStorageItem('sng-jwtRefreshToken', true);

        if (refreshToken) {

            return this._http.post(
                `${this.jwtPath}/auth/token`,
                `grant_type=refresh_token&refresh_token=${refreshToken}&client_id=${this.webApiClientId}`,
                {
                    headers: new HttpHeaders({
                        'SkipAuth': 'true'
                    })
                }
            ).pipe(
                map((r: any) => {

                    this.storage.setStorageItem('sng-jwToken', r['access_token']);
                    this.storage.setStorageItem('sng-refreshToken', r['refresh_token']);

                    this.updateParentFrameJwt(r['access_token'], r['refresh_token']);
                    
                    return r['access_token']

                })

            )

        } else {

            return of('noRefreshToken')

        }

    }

    public updateParentFrameJwt = (jwt: string, jwtRefreshToken: string): boolean => {
        //if our jwt is refreshed in Cust Man, we need to give the new jwt to the parent frame to otherwise when the parent frames original jwt expires it will fail to refresh within the parent frame

        let message = {
            messageType: 'updateJwt',
            jwt: jwt,
            jwtRefreshToken: jwtRefreshToken
        }

        try {
            window.parent.postMessage(message, '*')
            return true;
        }
        catch (e) {
            return false;
        }

    }

    public forceParentLogout = (): boolean => {

        let message = {
            messageType: 'logoutCustomer'
        }

        try {
            window.parent.postMessage(message, '*')
            return true;
        }
        catch (e) {
            return false;
        }

    }

}
